<div class="enhanced-select-container">
  <!-- Valor seleccionado con mejor visibilidad y botón X junto a la flecha -->
  <div class="selected-value" (click)="toggleOptionsDisplay()">
    <span *ngIf="selectedValue">
      {{ getDisplayText() }}
    </span>
    <span *ngIf="!selectedValue">
      {{ placeholder }}
    </span>
    <div class="action-buttons-container">
      <button 
        *ngIf="selectedValue" 
        class="clear-select-button" 
        (click)="$event.stopPropagation(); clearSelection()">
        ✕
      </button>
      <span class="dropdown-arrow">▼</span>
    </div>
  </div>
  
  <!-- Campo de búsqueda y opciones filtradas -->
  <div class="dropdown-container" *ngIf="showOptions">
    <!-- Campo de búsqueda dentro del dropdown -->
    <div class="search-input-container">
      <span class="search-icon">🔍</span>
      <input 
        type="text" 
        class="search-input"
        [placeholder]="'Buscar ' + placeholder.toLowerCase() + '...'" 
        [(ngModel)]="searchTerm" 
        (input)="filterOptions()"
        (keydown.enter)="selectFirstOption($event)"
        (keydown.arrowUp)="navigateList($event, -1)"
        (keydown.arrowDown)="navigateList($event, 1)"
        #searchInput
      >
    </div>
    
    <!-- Lista desplegable con opciones filtradas -->
    <div class="filtered-options">
      <div 
        *ngFor="let option of filteredOptions; let i = index" 
        class="option-item"
        [class.active]="option.value === selectedValue"
        [class.keyboard-selected]="i === selectedIndex"
        (click)="selectOption(option)"
        (mouseenter)="selectedIndex = i"
      >
        {{ option.label }}
      </div>
      <div *ngIf="filteredOptions.length === 0" class="option-item no-results">
        No se encontraron resultados
      </div>
    </div>
  </div>
  
  <!-- Selector original oculto (mantenemos para compatibilidad) -->
  <select 
    style="display: none;"
    [disabled]="disabled"
    [(ngModel)]="selectedValue"
    (ngModelChange)="onSelectionChange($event)"
  >
    <option [value]="null">{{ placeholder }}</option>
    <option *ngFor="let option of options" [value]="option.value">{{ option.label }}</option>
  </select>
</div> 